function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_T7CSnFV9cEkXXpgBchOrODEYAEWaNDXv"
}, /*#__PURE__*/React.createElement("rect", {
  width: 97,
  height: 97
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_T7CSnFV9cEkXXpgBchOrODEYAEWaNDXv)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: " M 72 22.063 L 47.913 46.15 C 47.129 46.933 47.129 48.304 47.913 49.088 C 48.696 49.871 50.067 49.871 50.85 49.088 L 74.938 25 L 82.183 25.979 L 95.5 12.663 L 85.708 11.292 L 84.337 1.5 L 70.825 15.013 L 72 22.063 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 83.75 29.896 C 86.687 35.379 88.45 41.646 88.45 48.5 C 88.45 70.433 70.629 88.254 48.696 88.254 C 26.567 88.254 8.746 70.433 8.746 48.5 C 8.746 26.567 26.567 8.746 48.5 8.746 C 55.158 8.746 61.425 10.313 67.104 13.25 L 72.392 7.962 C 65.342 3.85 57.117 1.5 48.5 1.5 C 22.65 1.5 1.5 22.65 1.5 48.5 C 1.5 74.35 22.65 95.5 48.5 95.5 C 74.35 95.5 95.5 74.35 95.5 48.5 C 95.5 39.883 93.15 31.658 89.038 24.608 L 83.75 29.896 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 66.908 21.671 C 61.621 17.95 55.354 15.992 48.5 15.992 C 30.483 15.992 15.992 30.483 15.992 48.5 C 15.992 66.517 30.483 81.008 48.5 81.008 C 66.517 81.008 81.008 66.517 81.008 48.5 C 81.008 41.646 78.854 35.379 75.329 30.092 L 70.042 35.379 C 72.392 39.296 73.762 43.8 73.762 48.5 C 73.762 62.404 62.404 73.762 48.5 73.762 C 34.596 73.762 23.238 62.404 23.238 48.5 C 23.238 34.596 34.596 23.237 48.5 23.237 C 53.396 23.237 57.9 24.608 61.621 26.958 L 66.908 21.671 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 48.5 37.729 C 49.283 37.729 50.067 37.729 50.654 37.925 L 56.333 32.246 C 53.983 31.071 51.242 30.483 48.5 30.483 C 38.513 30.483 30.483 38.512 30.483 48.5 C 30.483 58.488 38.513 66.517 48.5 66.517 C 58.488 66.517 66.517 58.488 66.517 48.5 C 66.517 45.758 65.929 43.017 64.754 40.667 L 59.075 46.346 C 59.075 46.346 59.075 46.346 59.075 46.346 C 59.271 47.129 59.271 47.717 59.271 48.5 C 59.271 54.571 54.375 59.271 48.5 59.271 C 42.429 59.271 37.729 54.375 37.729 48.5 C 37.729 42.429 42.429 37.729 48.5 37.729 Z ",
  fill: "rgb(255,255,255)"
})));

function SvgBullseye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 97 97",
    width: "97pt",
    height: "97pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullseye);
export default __webpack_public_path__ + "static/media/bullseye.d0ce797c.svg";
export { ForwardRef as ReactComponent };